import { Navigate, useLocation } from 'react-router-dom';

// Preserve existing contact links while using the existing home contact card.
export default function ContactPage() {
  const { search } = useLocation();
  return <Navigate replace to={{ pathname: '/', search, hash: '#contact' }} />;
}
